function windowUserAgent() {
  return window.navigator.userAgent;
}

export { windowUserAgent };